<app-template-notification [value]="value" [control]="control" [label]="label" [links]="links" [sslinks]="sslinks" />
